import script from "./HomeMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeMenu.vue?vue&type=script&setup=true&lang=js"

import "./HomeMenu.vue?vue&type=style&index=0&id=0c9e0c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9e0c38"]])

export default __exports__